import { Indicators } from 'component/Carousel/co/Indicators/Indicators'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { Carousel2 } from 'page/InferenceScreen/Carousel/Carousel2'
import { ImageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModal'
import { imageQrModal } from 'page/InferenceScreen/ImageQrModal/ImageQrModalStore'
import { Page } from 'page/Page/Page'
import { ItemsPane } from 'page/StandInferenceScreen/ItemsPane'
import { QrPane } from 'page/StandInferenceScreen/QrPane'
import { StandGeneratingScreen } from 'page/StandInferenceScreen/StandGeneratingScreen'
import { store } from 'store/store'

export const StandInferenceScreen = observer(() => {
  const { carousel } = store.carousel
  const { many, item } = carousel

  if (!item) return <StandGeneratingScreen />

  return (
    <Page full center>
      <Vertical pad={[0, 24]} gap={24} wide tall center>
        <Carousel2 />
        {many && <Space center>
          <Indicators carousel={carousel} compact />
        </Space>}
        <Space gap={16} wide top>
          <ItemsPane />
          <QrPane />
        </Space>
      </Vertical>
      {imageQrModal.present && <ImageQrModal />}
    </Page>
  )
})
